<template>
    <div class="results">
        <div v-for="(result, index) in results" :key="index" class="result">
            <NuxtLink :to="`/${result.localizedPagePaths[$i18n.localeProperties.code]}`">
                <div class="result-name">{{ result.content.title ?? result.content.station.name }}</div>
                <div v-if="result.content.description" class="result-description">
                    <span>{{ highlightedDescription(result.content.description).first }}</span>
                    <span class="highlight">{{ highlightedDescription(result.content.description).keyword }}</span>
                    <span>{{ highlightedDescription(result.content.description).second }}</span>
                </div>
                <div class="result-details">
                    <span class="result-tag">{{ $t(`search.${result.content.contentType}`) }}</span>
                    <span class="result-path">{{ result.localizedPagePaths[$i18n.localeProperties.code] }}</span>
                </div>
            </Nuxtlink>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    results: {
        type: Array,
        required: false,
        default: () => ([]),
    },
    prompt: {
        type: String,
        required: false,
        default: '',
    },
});

const highlightedDescription = text => {

    if (!text) return;

    const regex = new RegExp(props.prompt, 'gi');
    const split = text.split(regex);

    return { first: split[0], keyword: props.prompt, second: split[1] };

};

</script>

<style scoped>
.results {
  margin: 1rem 0;
}
.results .result {
  border-bottom: 1px solid var(--color-base-grey-200);
  padding: 1rem;
  margin: 0.25rem;
}
@media (max-width: 1199px) {
  .results .result {
    padding: 1rem 0;
    margin: 0 0.25rem;
  }
}
.results .result .result-name {
  font-size: 1rem;
  font-weight: 600;
}
.results .result .result-description {
  margin: 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 400;
}
.results .result .result-description .highlight {
  background-color: var(--color-primary-500);
  border-radius: 0.125rem;
  font-weight: 700;
  padding: 0 0.25rem;
}
.results .result .result-details {
  margin-top: 1rem;
}
.results .result .result-details .result-tag {
  padding: 0.25rem 0.5rem;
  margin: 0.5rem;
  margin-left: 0;
  border-radius: 0.5rem;
  background-color: var(--color-base-grey-200);
  color: var(--color-base-black);
}
.results .result .result-details .result-path {
  color: var(--color-base-grey-600);
}
</style>
